<header>
  <div style="display:none;" class="logo-bar">
    <div class="container" style="margin-bottom:0px;">
      <div class="row-no-margin header-shadow" style="padding-top:20px;padding-bottom:20px;">
        <div class="row-no-margin col-md-6">
          <div style="border-right: 1px solid #e2e1dd;">
            <a class="navbar-brand" [routerLink]="['/']">
              <img src="./assets/images/tolomatic-logo.png" />
            </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
<div class="container">
  <router-outlet></router-outlet>
</div>
